import Plyr from 'plyr';

export default class Players {
    constructor() {
        this.players = [];
        this.currentPlayingPlayer = null;
        this.init();
        this.events();
    }

    events(){

        window.addEventListener('reloadPlayer',(event)=>{
            this.init();
        });

    }

    init() {
        const plyrElements = document.querySelectorAll('.plyr-player');
        if (plyrElements.length === 0) {
            return;
        }

        const controlsPlayers = [
            'play-large',
            'play',
            'progress',
            'mute',
            'volume',
            'fullscreen'
        ];

        this.players = Plyr.setup('.plyr-player', {
            controls: controlsPlayers,
            clickToPlay: true,
            vimeo: {
                controls: 0
            },
            youtube: {
                noCookie: false,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1
            }
        });

        this.players.forEach(player => {
            player.on('play', () => {
                if (this.currentPlayingPlayer && this.currentPlayingPlayer !== player) {
                    this.currentPlayingPlayer.pause();
                }
                this.currentPlayingPlayer = player;
            });
        });

    }

    pauseCurrentVideo = () => {
        if (this.currentPlayingPlayer) {
            this.currentPlayingPlayer.pause();
        }
    }
}
